import type {PropsWithChildren} from 'react'
import {footer} from './footer.module.scss'

type Props = PropsWithChildren<object>

export const Footer = ({children}: Props) => <div className={footer}>{children}</div>
